import { generatePath } from 'react-router-dom'
import { BRAND_KITS_PATH, UPLOADS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Upload5 } from 'blaze-ui/icons'
import Styles from 'blaze-components/WorkspaceDashboardSidebar/components/NavMenu/NavMenu.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuUploadsItem = ({ workspaceId, onPress }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const isAutopilot = useIsVirtualMarketer()
  const isSystemRedesignEnabled = useIsSystemRedesign()

  const path = isAutopilot
    ? `${generatePath(BRAND_KITS_PATH, { workspaceId })}#images_videos`
    : generatePath(UPLOADS_PATH, { workspaceId })

  let label = isAutopilot ? 'Brand Media' : 'Uploads'
  if (isSystemRedesignEnabled) label = 'Media Library'

  return (
    <NavMenuItem
      size="md"
      icon={Upload5}
      activeIcon={({ color }: { color?: string }) =>
        isSystemRedesignEnabled ? (
          <Upload5 color={color} size={15} />
        ) : (
          <div className={Styles.iconFilled}>
            <Upload5 color={color} size={isMobile ? 24 : 20} />
          </div>
        )
      }
      to={path}
      onPress={onPress}
      label={label}
    />
  )
}

export { NavMenuUploadsItem }
